// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2Gnx1","alertIcon":"ConfirmModal_alertIcon__3JWxa"};